module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAABQUlEQVR42t3WW3GEMBiG4S8OcLBIQAIWqmCpg3UAdVAHrINK2VYBEpDw9qJ/ZzKZbMopYaa5AsKQZ/5DgvQfB9AAM3A9G/EAWmA6BeMharuvi2NChPe8HMZD3IEqMl/zM6oikQCqGAbogLFoOmIYYAC6ojURwwC3MCKHpCmFSGAewGhp6q1mrlkRCUwHvFuEms3dtAaRqpldrb0FcThmD2IhpgXm7Ig/Wru27zdFEDHMaYgIZhFiyoHYko4B6M9G1N4G1BdF2Isz0EZOzr4Ywlt0ivzc7MKsQuTCrEW4cFFJvaQXSa2ki6Qvm744596WIiR9SHp1zn1uDWdnR/Vg1799vygym9KR2niC+7sd4UnMoYhElIZUzWRH2CKj/+8ZYkohKquZaDcVQSxo7Zs9z494hikaiQSmPQ0RYOZTETnHN4ADHwh5wwxIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/ticket.png
// module id = 50
// module chunks = 51